import m from "../../../../geodata/es2015/region/usa/utLow";
window.am4geodata_region_usa_utLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/utLow.js
// module id = null
// module chunks = 